"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8456],{

/***/ 1797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18722);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97349);
/* harmony import */ var _components_Redirect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20282);





var ModalContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ep36i5l0"
})("display:flex;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xxl */ .W0.xxl, ";", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, ";}");
var ModalTitleBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ep36i5l1"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";");
var ModalTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3", {
    target: "ep36i5l2"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h3 */ .JB.h3, ";font-weight:900;text-align:center;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h5 */ .JB.h5, ";}");
var ModalDescription = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ep36i5l3"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p3 */ .JB.p3, ";color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray900 */ .DG.gray900, ";");
var DescriptionText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p", {
    target: "ep36i5l4"
})("text-align:center;");
var ImageBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ep36i5l5"
})("display:flex;align-items:center;justify-content:center;");
var ImageBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("figure", {
    target: "ep36i5l6"
})("display:flex;align-items:center;justify-content:center;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(120);
}, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(120);
}, ";border-radius:2.5rem;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, " ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";}");
var ButtonGroup = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "ep36i5l7"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";button{max-width:418px;width:100%;flex:1;font-weight:600;}");
var EmailVerifyModal = function(param) {
    var isOpen = param.isOpen, handleOpen = param.handleOpen;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        handleOpen: handleOpen,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ImageBlock, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ImageBox, {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            src: "/assets/images/email/mail-verified.png",
                            height: "120px",
                            width: "120px",
                            alt: "mail-verified"
                        })
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ModalTitleBlock, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ModalTitle, {
                            children: "Verify your E-mail"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(ModalDescription, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(DescriptionText, {
                                    children: "E-mail registration isn't complete."
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(DescriptionText, {
                                    children: "Go to the Email Authentication page."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(ButtonGroup, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_components_Redirect__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        to: "/email/verification",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                            size: "lg",
                            children: "Move to page"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmailVerifyModal);


/***/ }),

/***/ 91097:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Modal_TransactionModal; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/@playdapp/ui/dist/index.esm.js
var index_esm = __webpack_require__(18722);
// EXTERNAL MODULE: ./src/store/hooks.ts
var hooks = __webpack_require__(57345);
// EXTERNAL MODULE: ./src/store/marketplace.ts
var marketplace = __webpack_require__(60152);
// EXTERNAL MODULE: ./src/store/marketplaceSolana.ts + 9 modules
var marketplaceSolana = __webpack_require__(75090);
// EXTERNAL MODULE: ./src/hooks/useWindowWidth.tsx
var useWindowWidth = __webpack_require__(37358);
// EXTERNAL MODULE: ./src/data/viewports.ts
var viewports = __webpack_require__(88916);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/data/transactionModal.ts


var STATUS_KEY = {
    INITIALIZE_PROXY: "INITIALIZE_PROXY",
    APPROVE_ALL_ASSETS: "APPROVE_ALL_ASSETS",
    APPROVE_CURRENCY_PLA: "APPROVE_CURRENCY_PLA",
    APPROVE_CURRENCY_WETH: "APPROVE_CURRENCY_WETH",
    APPROVE_CURRENCY_KLAY: "APPROVE_CURRENCY_KLAY",
    CREATE_ORDER_LISTING: "CREATE_ORDER_LISTING",
    CREATE_ORDER_MAKE_OFFER: "CREATE_ORDER_MAKE_OFFER",
    FULFILL_ORDER_OFFER_ACCEPT: "FULFILL_ORDER_OFFER_ACCEPT",
    FULFILL_ORDER_BUY: "FULFILL_ORDER_BUY",
    SET_PENDING_TRANSACTION_HASH: "SET_PENDING_TRANSACTION_HASH",
    TX_FAILED: "TX_FAILED",
    TRANSFER_ALL: "TRANSFER_ALL",
    TRANSFER_ONE: "TRANSFER_ONE",
    WRAP_ETH: "WRAP_ETH"
};
var _obj;
var transferContents = (_obj = {}, (0,_define_property/* default */.Z)(_obj, STATUS_KEY.INITIALIZE_PROXY, {
    heading: "Initialize your account",
    body: [
        "Signing this transaction in your wallet will allow you transact on Marketplace.",
        "Please confirm this transaction to proceed. This will incur a one-time gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj, STATUS_KEY.APPROVE_ALL_ASSETS, {
    heading: "Unlocking items for trading",
    body: [
        "Signing this transaction in your wallet will allow you to trade this item and any item in the same collection on Marketplace.",
        "Please confirm this transaction to proceed. This will incur a one-time gas fee for this item/collection.", 
    ]
}), (0,_define_property/* default */.Z)(_obj, STATUS_KEY.SET_PENDING_TRANSACTION_HASH, {
    heading: "Finalizing",
    body: [
        "Waiting for blockchain confirmation.",
        "The gift will be delivered soon.", 
    ]
}), _obj);
var _obj1;
var contents = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.INITIALIZE_PROXY, {
    heading: "Initialize your account",
    body: [
        "Signing this transaction in your wallet will allow you transact on Marketplace.",
        "Please confirm this transaction to proceed. This will incur a one-time gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.APPROVE_ALL_ASSETS, {
    heading: "Unlocking items for trading",
    body: [
        "Signing this transaction in your wallet will allow you to trade this item and any item in the same collection on Marketplace.",
        "Please confirm this transaction to proceed.",
        "This will incur a one-time gas fee for this item/collection.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.APPROVE_CURRENCY_PLA, {
    heading: "Approve PLA transaction",
    body: [
        "Signing this transaction in your wallet will approve your wallet to use PLA for transactions on Marketplace.",
        "Please confirm this transaction to proceed.",
        "This will incur a one-time gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.APPROVE_CURRENCY_WETH, {
    heading: "Approve WETH transaction",
    body: [
        "Signing this transaction in your wallet will approve your wallet to use WETH for transactions on Marketplace.",
        "Please confirm this transaction to proceed.",
        "This will incur a one-time gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.APPROVE_CURRENCY_KLAY, {
    heading: "Approve KLAY transaction",
    body: [
        "Signing this transaction in your wallet will approve your wallet to use KLAY for transactions on Marketplace.",
        "Please confirm this transaction to proceed.",
        "This will incur a one-time gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.CREATE_ORDER_LISTING, {
    heading: "Listing",
    body: [
        "Please sign in your wallet to list your item on Marketplace.",
        "This process will not incur a gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.CREATE_ORDER_MAKE_OFFER, {
    heading: "Finalizing",
    body: [
        "Please sign in your wallet to verify your offer to the seller.",
        "This process will not incur a gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.FULFILL_ORDER_OFFER_ACCEPT, {
    heading: "Finalizing",
    body: [
        "Please confirm this smart contract by signing in your wallet to complete your sale.",
        "This process will incur a gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.FULFILL_ORDER_BUY, {
    heading: "Finalizing",
    body: [
        "Please confirm this smart contract by signing in your wallet to purchase this item.",
        "This process will incur a gas fee.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.TRANSFER_ALL, {
    heading: "Finalizing",
    body: [
        "Waiting for blockchain confirmation.",
        "The gift will be delivered soon.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.TRANSFER_ONE, {
    heading: "Finalizing",
    body: [
        "Waiting for blockchain confirmation.",
        "The gift will be delivered soon.", 
    ]
}), (0,_define_property/* default */.Z)(_obj1, STATUS_KEY.WRAP_ETH, {
    heading: "Finalizing",
    body: [
        "Waiting for blockchain confirmation."
    ]
}), _obj1);
var commonSteps = [
    {
        title: "Initialize",
        icon: "initialize"
    },
    {
        title: "Unlock Item",
        icon: "unlock"
    }, 
];
var steps = {
    eth: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    matic: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    pla: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve PLA",
            icon: "approve"
        },
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    sol: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    weth: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve WETH",
            icon: "approve"
        },
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    klay: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve KLAY",
            icon: "approve"
        },
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    wklay: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve WKLAY",
            icon: "approve"
        },
        {
            title: "Listing",
            icon: "complete"
        }, 
    ]),
    plaAcceptOffer: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve PLA",
            icon: "approve"
        },
        {
            title: "Processing",
            icon: "complete"
        }, 
    ]),
    wethAcceptOffer: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Approve WETH",
            icon: "approve"
        },
        {
            title: "Processing",
            icon: "complete"
        }, 
    ]),
    plaMakeOffer: [
        {
            title: "Approve PLA",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    wethMakeOffer: [
        {
            title: "Approve WETH",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    wklayMakeOffer: [
        {
            title: "Approve WKLAY",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    solMakeOffer: [
        {
            title: "Approve SOL",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    transfer: (0,_to_consumable_array/* default */.Z)(commonSteps).concat([
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ]),
    plaBuy: [
        {
            title: "Approve PLA",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    wethBuy: [
        {
            title: "Approve WETH",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    solBuy: [
        {
            title: "Approve SOL",
            icon: "approve"
        },
        {
            title: "Authorizing",
            icon: "complete"
        }, 
    ],
    Buy: (0,_to_consumable_array/* default */.Z)(commonSteps)
};
/* harmony default export */ var transactionModal = (null);

// EXTERNAL MODULE: ./src/lib/environment.ts
var environment = __webpack_require__(51289);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/Icon.tsx
var Icon = __webpack_require__(69583);
;// CONCATENATED MODULE: ./src/components/Step.tsx
/* eslint-disable react/function-component-definition */ /* eslint-disable import/extensions */ /* eslint-disable no-nested-ternary */ /* eslint-disable react/no-array-index-key */ 



var StepBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3od2f10"
})("display:flex;flex-direction:column;align-items:center;position:relative;margin-right:60px;", index_esm/* breakpoints.down */.AV.down("lg"), "{flex-direction:row;margin-right:0;width:", function(param) {
    var stepCount = param.stepCount;
    return stepCount === 2 ? "40%" : stepCount === 3 ? "70%" : "100%";
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{justify-content:space-between;width:", function(param) {
    var stepCount = param.stepCount;
    return "".concat(stepCount * 70, "px");
}, ";}");
var StepBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3od2f11"
})("position:absolute;top:", function(param) {
    var position = param.position;
    return position;
}, ";left:50%;height:", function(param) {
    var size = param.size;
    return size;
}, ";border:0.5px solid ", function(param) {
    var color = param.color;
    return color;
}, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{flex-direction:row;top:50%;left:", function(param) {
    var position = param.position;
    return position;
}, ";height:auto;width:", function(param) {
    var size = param.size;
    return size;
}, ";}");
var Stepper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e3od2f12"
})("display:flex;align-items:center;justify-content:center;position:relative;img{z-index:1;}.spinner{position:absolute;width:54px;height:54px;*{width:100%;height:100%;}}& + &{margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(40);
}, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:0;margin-left:", function(param) {
    var theme = param.theme;
    return theme.rem(87);
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-left:", function(param) {
    var stepCount = param.stepCount;
    return stepCount === 2 ? "calc(80% - 50px)" : "calc(33% - 50px)";
}, ";}}");
var Step = function(param) {
    var step = param.step, stepBarSize = param.stepBarSize, stepInfo = param.stepInfo;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StepBlock, {
        stepCount: stepInfo.length,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepBar, {
                position: "0",
                size: stepBarSize,
                color: index_esm/* palette.primary600 */.DG.primary600
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StepBar, {
                position: stepBarSize,
                size: "calc(100% - ".concat(stepBarSize, ")"),
                color: index_esm/* palette.gray600 */.DG.gray600
            }),
            stepInfo.map(function(item, idx) {
                var active = idx + 1 === step;
                var iconName = step > idx + 1 ? "check" : item.icon;
                if (iconName !== "check" && iconName !== "initialize" && iconName !== "unlock-gray" && iconName !== "approve-gray" && iconName !== "complete-gray" && step < idx + 1) {
                    iconName = "".concat(iconName, "-gray");
                }
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Stepper, {
                    stepCount: stepInfo.length,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                            name: iconName,
                            size: "40px"
                        }),
                        active && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            className: "spinner",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Progress */.Ex, {
                                type: "grow",
                                color: index_esm/* palette.primary600 */.DG.primary600
                            })
                        })
                    ]
                }, "transaction-modal-step-".concat(idx));
            })
        ]
    });
};
/* harmony default export */ var components_Step = (Step);

// EXTERNAL MODULE: ./src/components/Modal/TransactionResultModal.tsx
var TransactionResultModal = __webpack_require__(20508);
;// CONCATENATED MODULE: ./src/components/Modal/TransactionModal.tsx














var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmajjy0"
})("display:flex;justify-content:center;align-items:center;padding:0 ", index_esm/* spacing.m */.W0.m, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{flex-direction:column;padding:0;}");
var ContentsBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmajjy1"
})("display:flex;flex-direction:column;justify-content:center;width:", function(param) {
    var theme = param.theme;
    return theme.rem(586);
}, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{width:100%;margin-top:", index_esm/* spacing.xxl */.W0.xxl, ";}");
var ButtonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmajjy2"
})("display:flex;justify-content:flex-end;margin-top:", index_esm/* spacing.xxl */.W0.xxl, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{justify-content:center;}");
var Heading = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmajjy3"
})("margin-bottom:", index_esm/* spacing.l */.W0.l, ";color:", index_esm/* palette.black */.DG.black, ";", (0,index_esm/* fontStyle */.p_)("h3"), " ", index_esm/* breakpoints.down */.AV.down("lg"), "{text-align:center;}");
var Body = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ehmajjy4"
})("color:", index_esm/* palette.gray900 */.DG.gray900, ";", (0,index_esm/* fontStyle */.p_)("p1"), " ", index_esm/* breakpoints.down */.AV.down("lg"), "{text-align:center;}");
var TransactionModal = function(param) {
    var status = param.status, currency = param.currency, _stepTypeSubFix = param.stepTypeSubFix, stepTypeSubFix = _stepTypeSubFix === void 0 ? "" : _stepTypeSubFix, network = param.network, txHash = param.txHash, isOpen = param.isOpen, _isShowSteps = param.isShowSteps, isShowSteps = _isShowSteps === void 0 ? true : _isShowSteps, _shouldCloseOnOverlayClick = param.shouldCloseOnOverlayClick, shouldCloseOnOverlayClick = _shouldCloseOnOverlayClick === void 0 ? false : _shouldCloseOnOverlayClick, handleOpen = param.handleOpen;
    var ref = (0,react.useState)("800px"), modalWidth = ref[0], setModalWidth = ref[1];
    var ref1 = (0,useWindowWidth/* default */.Z)(), width = ref1.width, handleResize = ref1.handleResize;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var data = (0,react.useMemo)(function() {
        if (!status || status === STATUS_KEY.TX_FAILED) return null;
        var stepType = stepTypeSubFix === "transfer" ? stepTypeSubFix : "".concat(currency).concat(stepTypeSubFix);
        var stepInfo = steps[stepType];
        var step = 1;
        if (status === STATUS_KEY.APPROVE_ALL_ASSETS || status === STATUS_KEY.CREATE_ORDER_MAKE_OFFER || status === STATUS_KEY.FULFILL_ORDER_BUY) {
            step = 2;
        } else if (stepTypeSubFix !== "Buy" && (status === STATUS_KEY.APPROVE_CURRENCY_PLA || status === STATUS_KEY.APPROVE_CURRENCY_WETH || status === STATUS_KEY.APPROVE_CURRENCY_KLAY || status === STATUS_KEY.TRANSFER_ALL || status === STATUS_KEY.TRANSFER_ONE || status === STATUS_KEY.WRAP_ETH)) {
            step = 3;
            if (stepTypeSubFix === "MakeOffer") {
                step = 1;
            }
        } else if (status === STATUS_KEY.CREATE_ORDER_LISTING || status === STATUS_KEY.FULFILL_ORDER_OFFER_ACCEPT) {
            step = 4;
            if (stepType === "matic" || stepType === "eth" || stepType === "sol" || stepType === "klay") {
                step = 3;
            }
        }
        var borderSize = width < viewports/* default.LARGE */.Z.LARGE ? 140 : 80;
        var stepBarSize = width < viewports/* default.MEDIUM */.Z.MEDIUM && stepInfo && stepInfo.length > 1 ? "".concat((step - 1) * (100 / (stepInfo.length - 1)), "%") : "".concat((step - 1) * borderSize, "px");
        return {
            contents: status ? contents[status] : null,
            stepInfo: stepInfo,
            step: step,
            stepBarSize: stepBarSize
        };
    }, [
        width,
        status,
        currency,
        stepTypeSubFix
    ]);
    var handleClearTxStatus = function() {
        dispatch((0,marketplace/* clearTxStatus */.Tz)());
        dispatch((0,marketplaceSolana/* clearTxStatus */.Tz)());
    };
    (0,react.useEffect)(function() {
        if (width < viewports/* default.MEDIUM */.Z.MEDIUM) {
            setModalWidth("100%");
        } else if (width < viewports/* default.LARGE */.Z.LARGE) {
            setModalWidth("500px");
        } else {
            setModalWidth("800px");
        }
    }, [
        width
    ]);
    (0,react.useEffect)(function() {
        handleResize();
    }, [
        handleResize
    ]);
    if (status === STATUS_KEY.TX_FAILED) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransactionResultModal/* default */.Z, {
            isOpen: status === STATUS_KEY.TX_FAILED,
            handleOpen: handleClearTxStatus,
            type: "error",
            txHash: null
        });
    }
    if (!(data === null || data === void 0 ? void 0 : data.contents) || !(data === null || data === void 0 ? void 0 : data.stepInfo) || !(data === null || data === void 0 ? void 0 : data.step) || !(data === null || data === void 0 ? void 0 : data.stepBarSize)) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
        isOpen: isOpen,
        hideCloseButton: true,
        width: modalWidth,
        shouldCloseOnOverlayClick: shouldCloseOnOverlayClick,
        handleOpen: handleOpen,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container, {
            children: [
                isShowSteps && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Step, {
                    step: data.step,
                    stepInfo: data.stepInfo,
                    stepBarSize: data.stepBarSize
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentsBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Heading, {
                            children: data.contents.heading
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body, {
                            children: data.contents.body.map(function(text, item) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: text
                                }, "text-".concat(item));
                            })
                        }),
                        txHash && network && status === STATUS_KEY.APPROVE_ALL_ASSETS && network !== "solana" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonBlock, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* default */.Z, {
                                to: "".concat(environment/* blockExplorerUrl */.Q["production"][network], "/tx/").concat(txHash),
                                children: "View Transaction"
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_TransactionModal = (TransactionModal);


/***/ }),

/***/ 20508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18722);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94829);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80871);
/* harmony import */ var lib_environment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51289);
/* harmony import */ var _components_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(68663);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69583);









var ModalContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi0"
})("display:flex;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xxl */ .W0.xxl, ";", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.l */ .W0.l, ";}");
var ModalTitleBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi1"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xxl */ .W0.xxl, ";", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.l */ .W0.l, ";}");
var ModalTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3", {
    target: "e17141qi2"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h3 */ .JB.h3, ";font-weight:900;text-align:center;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h4 */ .JB.h4, ";}");
var ImageBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi3"
})("display:flex;align-items:center;justify-content:center;");
var ImageBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("figure", {
    target: "e17141qi4"
})("display:flex;align-items:center;justify-content:center;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(120);
}, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(120);
}, ";border-radius:2.5rem;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("lg"), "{max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(80);
}, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(80);
}, ";}", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";}");
var TextBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi5"
})();
var ModalDescription = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p", {
    target: "e17141qi6"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p1 */ .JB.p1, ";color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray900 */ .DG.gray900, ";text-align:center;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("lg"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p3 */ .JB.p3, ";}", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p4 */ .JB.p4, ";}&:first-of-type{margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";}");
var ButtonGroup = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi7"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";a,button{width:100%;max-width:418px;}");
var TxHashBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e17141qi8"
})("display:flex;align-items:center;justify-content:center;color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray900 */ .DG.gray900, ";font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p4 */ .JB.p4, ";a{display:flex;align-items:center;justify-content:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";}");
var TransactionResultModal = function(param) {
    var isOpen = param.isOpen, handleOpen = param.handleOpen, type = param.type, network = param.network, txHash = param.txHash, errorDescription = param.errorDescription, afterCloseRedirectTo = param.afterCloseRedirectTo;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isLgDown = (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,lib_util__WEBPACK_IMPORTED_MODULE_3__/* .getBreakpointQuery */ .XR)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("lg")), false);
    var handleClose = function() {
        if (!afterCloseRedirectTo) {
            return;
        }
        if (/^https?:\/\//.test(afterCloseRedirectTo)) {
            window.open(afterCloseRedirectTo, "_blank");
            return;
        }
        router.push(afterCloseRedirectTo);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        isOpen: isOpen,
        handleOpen: handleOpen,
        shouldCloseOnOverlayClick: true,
        handleAfterClose: handleClose,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(ModalTitleBlock, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageBlock, {
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ImageBox, {
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                    name: "tx-".concat(type),
                                    size: 120
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(TextBlock, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ModalTitle, {
                                    children: type === "error" ? "Error" : "Your transaction succeed!"
                                }),
                                type === "error" && !errorDescription && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(ModalDescription, {
                                    children: [
                                        "An error has occurred.",
                                        isLgDown ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)("br", {}) : " ",
                                        'Please contact "Customer support".'
                                    ]
                                }),
                                type === "error" && errorDescription && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ModalDescription, {
                                    children: errorDescription
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(ButtonGroup, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        to: type === "error" ? afterCloseRedirectTo || "https://playdapp.atlassian.net/servicedesk/customer/portals" : "",
                        onClick: handleOpen,
                        children: "OK"
                    })
                }),
                type === "success" && network && txHash && network !== "solana" && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(TxHashBlock, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)("a", {
                        href: "".concat(lib_environment__WEBPACK_IMPORTED_MODULE_4__/* .blockExplorerUrl */ .Q["production"][network], "/tx/").concat(txHash),
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            "View on ",
                            (0,lib_util__WEBPACK_IMPORTED_MODULE_3__/* .toPascalCase */ .Mh)(network),
                            "scan ",
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                name: "link",
                                size: 18
                            }),
                            " "
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (TransactionResultModal);


/***/ }),

/***/ 88916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18722);

var viewports = {
    EXTRA_LARGE: _playdapp_ui__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.values */ .AV.values("xl"),
    LARGE: _playdapp_ui__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.values */ .AV.values("lg"),
    MEDIUM: _playdapp_ui__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.values */ .AV.values("md"),
    SMALL: _playdapp_ui__WEBPACK_IMPORTED_MODULE_0__/* .breakpoints.values */ .AV.values("sm")
};
/* harmony default export */ __webpack_exports__["Z"] = (viewports);


/***/ }),

/***/ 37358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23279);
/* harmony import */ var lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_debounce__WEBPACK_IMPORTED_MODULE_1__);


var useWindowWidth = function(initWidth) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initWidth || 0), width = ref[0], setWidth = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), height = ref1[0], setHeight = ref1[1];
    var handleResize = lodash_debounce__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        setWidth(window.innerWidth);
    }, 100);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var isMounted = true;
        if (true) {
            setHeight(window.innerHeight);
            if (isMounted) {
                window.addEventListener("resize", handleResize);
            }
        }
        return function() {
            if (true) {
                isMounted = false;
                window.removeEventListener("resize", handleResize);
            }
        };
    }, [
        handleResize
    ]);
    return {
        width: width,
        height: height,
        handleResize: handleResize
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowWidth);


/***/ })

}]);